/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProcessingPurpose = {
    SystemOperation: 'SYSTEM_OPERATION',
    BusinessProcess: 'BUSINESS_PROCESS',
    DataAnalysis: 'DATA_ANALYSIS',
    None: 'NONE'
} as const;
export type ProcessingPurpose = typeof ProcessingPurpose[keyof typeof ProcessingPurpose];


export function instanceOfProcessingPurpose(value: any): boolean {
    for (const key in ProcessingPurpose) {
        if (Object.prototype.hasOwnProperty.call(ProcessingPurpose, key)) {
            if (ProcessingPurpose[key as keyof typeof ProcessingPurpose] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProcessingPurposeFromJSON(json: any): ProcessingPurpose {
    return ProcessingPurposeFromJSONTyped(json, false);
}

export function ProcessingPurposeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProcessingPurpose {
    return json as ProcessingPurpose;
}

export function ProcessingPurposeToJSON(value?: ProcessingPurpose | null): any {
    return value as any;
}

export function ProcessingPurposeToJSONTyped(value: any, ignoreDiscriminator: boolean): ProcessingPurpose {
    return value as ProcessingPurpose;
}

